import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {loadActiveVenue, logoutUser, toggleShowHeader, toggleShowScreenLoader} from './App/AppActions';
import {
  getAccessListFetchingStatus,
  getActiveVenue,
  getActiveVenueId,
  getAuthenticatedState,
  getCheckingTokenStatus,
  getPartnerAccount,
  getScreenLoaderStatus,
  getSessionUserId,
  getUser,
  getUserPermissions,
  getVenueDetail,
  getVenueList
} from './App/AppReducer';
import Header from '../components/Header/Header';
import {Outlet} from 'react-router';
import ScreenLoader from '../components/Loader/ScreenLoader';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {MenuRounded} from '@mui/icons-material';
import Connector from '../Connector';
import {withRoute} from 'util/withRoute';
import Sidebar from '../components/SideBar/SideBar';


class AuthWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowSideBar: window.innerWidth > 800 ? true : false,
      sidebarWidth: '255px',
      windowWidth: window.innerWidth
    };
  }

  componentDidMount() {
    this.props.dispatch(toggleShowHeader(false));
    if (this.props.isCheckingForToken || !this.props.isAuthenticated) {
      this.props.dispatch(toggleShowScreenLoader(true));
    }
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    this.props.dispatch(toggleShowHeader(true));
    window.removeEventListener('resize', this.handleResize)
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isCheckingForToken && !this.props.isAuthenticated && this.props.location && this.props.location.pathname) {
      return this.props.navigate(`/login?ref=${this.props.location.pathname}`);
    }
    if (prevProps.isCheckingForToken && !this.props.isCheckingForToken) {
      this.props.dispatch(toggleShowScreenLoader(false));
    }
  }

  handleResize = () => {
    this.setState({windowWidth: window.innerWidth})
  }

  toggleSideBar = () => {
    this.setState((prev) => ({ isShowSideBar: !prev.isShowSideBar }));
  };

  handleChangeActiveVenue = (venue) => {
    this.props.dispatch(toggleShowScreenLoader(true));
    this.props.dispatch(loadActiveVenue(venue));
    this.props.navigate('/dashboard');
  };

  handleLogOut = () => {
    this.props.dispatch(logoutUser());
    this.props.navigate('/')
  };

  showMessage = (msg, msgtype) => {
    switch (msgtype) {
      case 'warning':
        toast.warning(msg, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        break;
      case 'error':
        toast.error(msg, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        break;
      case 'info':
        toast.info(msg, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        break;
      case 'success':
        toast.success(msg, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        break;
      default:
        toast(msg, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
    }
  };

  render() {
    let breakpoint = 800;
    const { isShowSideBar, windowWidth } = this.state;
    const isDesktop = windowWidth > breakpoint;

    if (this.props.isAuthenticated) {
      return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#F5F7FB' }}>

          {/* ── DESKTOP SIDEBAR ── */}
          {isDesktop && (
            <div style={{
              width: isShowSideBar ? '255px' : '78px',
              minWidth: isShowSideBar ? '255px' : '78px',
              flexShrink: 0,
              height: '100vh',
              backgroundColor: '#F5F7FB',
              padding: '0px',
              boxSizing: 'border-box',
              transition: 'width 0.25s ease, min-width 0.25s ease',
              zIndex: 1100,
            }}>
              <Connector user={this.props.user} showMessage={this.showMessage} userPermissions={this.props.userPermissions} />
              <Sidebar
                windowWidth={this.state.windowWidth}
                toggleSideBar={this.toggleSideBar}
                isShowSideBar={isShowSideBar}
                venueList={this.props.venueList}
                activeVenueId={this.props.activeVenueId}
                activeVenue={this.props.activeVenue}
                activeUrl={this.props.currentURL}
                user={this.props.user}
                handleLogOut={this.handleLogOut}
                userPermissions={this.props.userPermissions}
                partneraccount={this.props.partneraccount}
              />
            </div>
          )}

          {/* ── MAIN CONTENT ── */}
          <div style={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden',
            transition: 'all 0.25s ease',
          }}>
            {/* Header */}
            <div className="vm-header-container" style={{
              height: '60px',
              flexShrink: 0,
              zIndex: 1000,
              width: '100%',
            }}>
              <Header
                toggleSideBar={this.toggleSideBar}
                breakpoint={breakpoint}
                windowWidth={this.state.windowWidth}
                isShowSidebar={isShowSideBar}
                venueList={this.props.venueList}
                venueDetails={this.props.venueDetails}
                activeVenue={this.props.activeVenue}
                handleChangeActiveVenue={this.handleChangeActiveVenue}
                isAuthenticated={this.props.isAuthenticated}
                profileHeader={true}
              />
            </div>

            {/* Scrollable page content */}
            <div
              className="container-fluid right-part-y-scroll"
              style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', width: '100%', padding: 0, background: '#F5F7FB' }}
            >
              <Outlet context={this.props} />
            </div>
          </div>

          {/* ── MOBILE SIDEBAR OVERLAY ── */}
          {!isDesktop && (
            <>
              <div style={{
                width: '80vw',
                position: 'fixed',
                zIndex: 3300,
                top: 0,
                minHeight: '100vh',
                left: isShowSideBar ? '0' : '-110vw',
                transition: 'left 0.2s ease-in-out',
              }}>
                <Sidebar
                  windowWidth={this.state.windowWidth}
                  toggleSideBar={this.toggleSideBar}
                  isShowSideBar={isShowSideBar}
                  venueList={this.props.venueList}
                  activeVenueId={this.props.activeVenueId}
                  activeVenue={this.props.activeVenue}
                  activeUrl={this.props.currentURL}
                  user={this.props.user}
                  handleLogOut={this.handleLogOut}
                  userPermissions={this.props.userPermissions}
                  partneraccount={this.props.partneraccount}
                />
              </div>
            </>
          )}
        </div>
      );
    } else {
      return <ScreenLoader style={{ position: 'absolute' }} />;
    }
  }
}

AuthWrapper.propTypes = {
  children: PropTypes.element,
};

function mapStateToProps(state, ownProps) {
  return {
    userId: getSessionUserId(state),
    isAuthenticated: getAuthenticatedState(state),
    venueList: getVenueList(state),
    venueDetails: getVenueDetail(state),
    activeVenue: getActiveVenue(state),
    activeVenueId: getActiveVenueId(state),
    currentURL: ownProps?.location?.pathname,
    user: getUser(state),
    isShowScreenLoader: getScreenLoaderStatus(state),
    userPermissions: getUserPermissions(state),
    isFetchingAccessList: getAccessListFetchingStatus(state),
    isCheckingForToken: getCheckingTokenStatus(state),
    userPermission: getUserPermissions(state),
    partneraccount: getPartnerAccount(state),
    ...ownProps,
  };
}

export default connect(mapStateToProps)(withRoute(AuthWrapper));